(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidLabCompendium', CovidLabCompendium);

    CovidLabCompendium.$inject = ['$resource'];

    function CovidLabCompendium ($resource) {
        var resourceUrl =  'api/covid-lab-compendiums/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFacility': {
                url: 'api/covid-lab-compendiums/by-facility/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
